{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Operatöre aktar",
    "MESSAGE": "Beni bir operatöre aktar"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "İndir",
      "UPLOADING": "Yükleniyor ..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Yolla"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Mesajı tekrar gönder",
      "ERROR_MESSAGE": "Gönderilemedi, tekrar deneyin"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Bu cevabın kalitesini değerlendirin"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Lütfen bir temsilcinin katılmasını bekleyin"
  },
  "ROBOT_CHECK": {
    "TITLE": "Hızlı güvenlik kontrolü",
    "DESCRIPTION": "Lütfen aşağıdaki kontrolü tamamlayın.",
    "VERIFYING": "Doğrulanıyor…",
    "ERROR": "Bu işe yaramadı. Lütfen tekrar deneyin.",
    "RETRY": "Tekrar dene"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Çevrimiçi",
    "OFFLINE": "Şu an operatörlerimiz müsait değil",
    "ONLINE_WITH_BOT": "Ekibimiz ve yapay zekâ asistanımız çevrimiçi",
    "OFFLINE_WITH_BOT": "Yapay zekâ asistanımız size yardımcı olmak için burada",
    "BOT_ONLY_REPLY": "Hemen yanıt verir"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Genellikle birkaç dakika içinde yanıt verir",
    "IN_A_FEW_HOURS": "Genellikle birkaç saat içinde yanıt verir",
    "IN_A_DAY": "Genellikle bir gün içinde yanıtlar",
    "BACK_IN": "Tekrar çevrim içi olacağız"
  },
  "DAY_NAMES": {
    "SUNDAY": "Pazar",
    "MONDAY": "Pazartesi",
    "TUESDAY": "Salı",
    "WEDNESDAY": "Çarşamba",
    "THURSDAY": "Perşembe",
    "FRIDAY": "Cuma",
    "SATURDAY": "Cumartesi"
  },
  "START_CONVERSATION": "Görüşmeyi Başlatın",
  "END_CONVERSATION": "Görüşmeyi Sonlandır",
  "CONTINUE_CONVERSATION": "Görüşmeye devam et",
  "YOU": "Sen",
  "START_NEW_CONVERSATION": "Yeni Görüşme Başlatın",
  "RESOLVE_LATER": "Bu konuyu e-posta/telefon ile çözeceğiz. Şimdi başka bir şey sormak istiyorum.",
  "VIEW_UNREAD_MESSAGES": "Okunmamış mesajlarınız var",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Yeni mesajları gör",
    "CLOSE_MESSAGES_BUTTON": "Kapat",
    "COMPANY_FROM": "dan",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Sohbet et"
  },
  "POWERED_BY": "{brandName} tarafından desteklenmektedir",
  "EMAIL_PLACEHOLDER": "Lütfen E-postanızı Girin",
  "CHAT_PLACEHOLDER": "Mesajınız",
  "TODAY": "Bugün",
  "YESTERDAY": "Dün",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Ad Soyad",
        "PLACEHOLDER": "lütfen tam adınızı giriniz",
        "REQUIRED_ERROR": "Tam isim gerekli"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-posta adresi",
        "PLACEHOLDER": "Lütfen e-eposta adresinizi girin",
        "REQUIRED_ERROR": "e-Posta adresi zorunludur",
        "VALID_ERROR": "Lütfen geçerli bir e-posta adresi girin"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefon numarası",
        "PLACEHOLDER": "Lütfen telefon numaranızı yazınız",
        "REQUIRED_ERROR": "Telefon numarası zorunludur",
        "DIAL_CODE_VALID_ERROR": "Lütfen bir ülke kodu seçin",
        "VALID_ERROR": "Lütfen geçerli bir telefon numarası girin",
        "DROPDOWN_EMPTY": "Sonuç bulunamadı",
        "DROPDOWN_SEARCH": "Ülke ismi giriniz"
      },
      "MESSAGE": {
        "LABEL": "Mesaj",
        "PLACEHOLDER": "Lütfen mesajınızı girin",
        "ERROR": "Mesaj çok kısa"
      }
    },
    "CAMPAIGN_HEADER": "Görüşmeye başlamadan önce lütfen isminizi ve e-posta adresinizi belirtiniz",
    "IS_REQUIRED": "zorunlu",
    "REQUIRED": "Zorunlu",
    "REGEX_ERROR": "Lütfen geçerli bir giriş yapın"
  },
  "FILE_SIZE_LIMIT": "Dosya {MAXIMUM_FILE_UPLOAD_SIZE} sınırını aşıyor",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Geçersiz alan"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "İfade ara",
    "NOT_FOUND": "İfade bulunamadı",
    "ARIA_LABEL": "Emoji seçimi"
  },
  "CSAT": {
    "TITLE": "Görüşmenizi değerlendirin",
    "SUBMITTED_TITLE": "Değerlendirmeniz için teşekkürler",
    "PLACEHOLDER": "Biraz daha fazla bilgi verin..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Konuşma kaydını talep et",
    "SEND_EMAIL_SUCCESS": "Sohbet metni başarıyla gönderildi",
    "SEND_EMAIL_ERROR": "Bir hata oluştu, lütfen tekrar deneyin"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popüler Makaleler",
    "VIEW_ALL_ARTICLES": "Tüm makaleleri görüntüle",
    "IFRAME_LOAD_ERROR": "Makale yüklenirken bir hata oluştu, lütfen sayfayı yenileyip tekrar deneyin."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Aç",
      "BUY": "Satın al"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Görsel mesaj"
    },
    "audio": {
      "CONTENT": "Sesli mesaj"
    },
    "video": {
      "CONTENT": "Video mesajı"
    },
    "file": {
      "CONTENT": "Dosya eklentisi"
    },
    "location": {
      "CONTENT": "Yer"
    },
    "fallback": {
      "CONTENT": "bir bağlantı paylaştı"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Cevap veriliyor:"
  }
}
